// LICENSE : MIT
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Is `v` is UseCaseFunction?
 */
exports.isUseCaseFunction = function (v) {
    return typeof v === "function";
};
//# sourceMappingURL=FunctionalUseCaseContext.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/FunctionalUseCaseContext.js
// module id = 476
// module chunks = 0